import { render, staticRenderFns } from "./OrigenStandar.vue?vue&type=template&id=5c4e2cc6"
import script from "./OrigenStandar.vue?vue&type=script&lang=js"
export * from "./OrigenStandar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports